export default function CheckoutPolicySection() {
    return (
        <div className="mx-4 mb-4 pt-4 pb-8 text-[14px]">
            With this order, I agree to the{' '}
            <a href="/terms" className="text-primary">
                Terms & Conditions
            </a>{' '}
            and{' '}
            <a href="/privacy-policy" className="text-primary">
                Privacy Policy
            </a>{' '}
            of ButcherCrowd
        </div>
    );
}
